import { TextStylePreset, Typography, TypographyProps } from '@vivaldis/antd-ui'

export const Title = ({
  textAlign = 'center',
  marginBottom = 20,
  ...props
}: TypographyProps<'span'>) => (
  <Typography.Text
    preset={TextStylePreset.Semibold18}
    marginBottom={marginBottom}
    textAlign={textAlign}
    style={{ whiteSpace: 'pre-line' }}
    {...props}
  />
)
